import React from "react";

const TOTAL_STEPS = 5;
const PROGRESS = {
    1: "w-[20%]",
    2: "w-[40%]",
    3: "w-[60%]",
    4: "w-[80%]",
    5: "w-[100%]",
};

const TemplateIndicator = ({ formIndex }) => {
    const currentStep = formIndex;
    return (
        <div className="flex items-center gap-4 flex-1 min-w-0">
            <div className="flex-1 min-w-0">
                <div className="mb-1.5">
                    <span className="text-sm font-medium text-gray-700">
                        Étape {currentStep} sur {TOTAL_STEPS}
                    </span>
                </div>
                <div className="h-2 w-full max-w-xs bg-gray-100 rounded-full overflow-hidden">
                    <div
                        className={`${
                            PROGRESS[formIndex] || "w-[0%]"
                        } bg-gradient-to-r from-yellow-400 to-yellow-500 h-full rounded-full transition-all duration-300 ease-out`}
                    />
                </div>
            </div>
        </div>
    );
};

export default TemplateIndicator;
